import { computed, ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'

/** 定位来源: 1-GPS 2-网络定位 3-IP解析 */
export const LOCATION_SOURCE_GPS = 1
export const LOCATION_SOURCE_NETWORK = 2
export const LOCATION_SOURCE_IP = 3

/** 定位来源文案映射（随语言切换） */
export function useLocationSourceLabels(): ComputedRef<Record<number, string>> {
  const { t, locale } = useI18n()
  return computed((): Record<number, string> => {
    void locale.value
    return {
      [LOCATION_SOURCE_GPS]: t('groupClient.locationSourceGps'),
      [LOCATION_SOURCE_NETWORK]: t('groupClient.locationSourceNetwork'),
      [LOCATION_SOURCE_IP]: t('groupClient.locationSourceIp')
    }
  })
}
